import type { MouseEvent } from 'react';

/**
 * True for an ordinary left click. Rows that are real links and also select in place
 * only take over a plain click, so open-in-new-tab and copy-link keep working.
 */
export function isPlainClick(e: MouseEvent): boolean {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}
